import { ActivityAttendance, CheckInCheckOutStep } from './checkInCheckOutCenter';

export enum VerificationRole {
  PARTICIPANT = 'PARTICIPANT',
  VOLUNTEER = 'VOLUNTEER',
  INSTRUCTOR = 'INSTRUCTOR',
  ORGANISATION = 'VOLUNTEER_ORGANIZATION'
}

export enum VerificationVolunteerType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE'
}

export interface AACCheckInCheckOutResponse {
  checkInDate?: string;
  checkOutDate?: string;
}

export interface AACVolunteerData {
  attendeeId: string;
  attendeeName: string;
  attendeeNRIC: string;
  attendeeRole: 'EXTERNAL_INSTRUCTOR' | 'PARTICIPANT' | 'VOLUNTEER' | 'VOLUNTEER_ORGANIZATION';
  primaryCoordinatorName?: string;
  secondaryCoordinatorName?: string;
  noOfVolunteers?: number;
}

export interface AACProfileValidateResponse extends AACVolunteerData {
  eventName: string;
  eventStart: string;
  eventEnd: string;
  alreadyCheckedIn: boolean;
  checkInDate: string | undefined;
  alreadyCheckedOut: boolean;
  checkOutDate: string | undefined;
}

export interface AACCheckInCheckOutState {
  loading: boolean;
  step: CheckInCheckOutStep;
  volunteerData?: AACVolunteerData;
  checkInCheckOut?: AACCheckInCheckOutResponse;
  showSomethingWentWrong?: boolean;
  verificationRole?: VerificationRole;
  nric?: string;
  selectedEvent?: ActivityAttendance;
  verificationType?: VerificationVolunteerType;
  verificationValue?: string;
  numberOfVolunteers?: number;
}
